type Frames = { outline: { border: number } };

export const frames: Frames = {
  outline: {
    border: 4,
  },
};
